import {FluidReplacementAfterMonthsInput} from '../components/FluidReplacementAfterMonthsInput';
import {LastFluidReplacementDatePicker} from '../components/LastFluidReplacementDatePicker';
import {LastFluidReplacementMileageInput} from '../components/LastFluidReplacementMileageInput';
import {NextFluidReplacementDatePicker} from '../components/NextFluidReplacementDatePicker';

export function BrakeFluidReplacementGroup() {
  return (
    <>
      <LastFluidReplacementDatePicker name="brakeFluid" />
      <LastFluidReplacementMileageInput name="brakeFluid" />
      <FluidReplacementAfterMonthsInput name="brakeFluid" />
      <NextFluidReplacementDatePicker name="brakeFluid" />
    </>
  );
}
